define(["require", "exports", "./CacheStorage", "./LocalStorage"], function (require, exports, CacheStorage_1, LocalStorage_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createCacheStorage = void 0;
    function createCacheStorage(namespace) {
        const urlNameSpace = isURL(namespace) ? namespace : convertToUrl(namespace);
        if (!isCacheSupported()) {
            return new LocalStorage_1.LocalStorage(urlNameSpace);
        }
        return new CacheStorage_1.CacheStorage(urlNameSpace);
    }
    exports.createCacheStorage = createCacheStorage;
    function isCacheSupported() {
        try {
            return window.caches && typeof window.caches.open === 'function';
        }
        catch (_) {
            return false;
        }
    }
    function isURL(maybeUrl) {
        try {
            const url = new URL(maybeUrl);
            return url.protocol === "http:" || url.protocol === "https:";
        }
        catch (_) {
            return false;
        }
    }
    function convertToUrl(str) {
        return `${window.location.origin}/_cache/${str}`;
    }
});
